module.exports = __webpack_public_path__ + "img/pointer.48d01ee3.svg";